import type { ExperimentConfig } from '../@types'

// A/B/C — DEV-34685. Pre-paywall workout-program block on activity-female-walking.
//
// NOTE on the variant→element mapping (`getAppAreaExperiment`, src/funnels/funnels.ts:204-217):
// `variantIndex = variant > 0 ? variant - 1 : 0`, so variant 0 (control) AND variant 1 (B) both
// resolve to element [0]. That means `ob-female-activity-walking-workout-program-b` serves the
// CONTROL group as well as B — the split between them happens inside that funnel, via the
// `featureKey != / ==` screen pair on `personalized-plan-walking`. Variant 2 (C) gets element [1].
const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_f_walking_workout_program~1
			funnel: {
				id: 'ob-female-activity-walking-workout-program-b',
				locale: ['en'],
			},
		},
	},
	{
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_f_walking_workout_program~2
			funnel: {
				id: 'ob-female-activity-walking-workout-program-c',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_f_walking_workout_program~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_f_walking_workout_program__c'
					),
			},
		},
	},
]

export default config
